import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { contentApi } from '../../services/contentApi';
import { CourseEnrollment } from '../../types/content';
import Button from '../../components/UI/Button';
import CourseFee from '../../components/UI/CourseFee';
import { PageLoading } from '../../components/UI/LoadingOverlay';

const MyLearningPage: React.FC = () => {
  const [enrollments, setEnrollments] = useState<CourseEnrollment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentApi.myCourseEnrollments()
      .then((r) => setEnrollments(r.data.enrollments || []))
      .catch(() => undefined)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold">My Learning</h1>
      <p className="mt-2 text-gray-600">Courses you enrolled in — continue from any enrollment type, including complimentary, invite, and pending payment.</p>
      {loading && <PageLoading label="Loading your courses…" />}
      {!loading && enrollments.length === 0 && (
        <div className="mt-6">
          <p className="text-gray-500">You have not enrolled in a course yet.</p>
          <Link to="/courses" className="mt-4 inline-block"><Button>Browse courses</Button></Link>
        </div>
      )}
      <div className="mt-6 space-y-3">
        {enrollments.map((item) => (
          <div key={item.id} className="surface-card p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <Link to={`/courses/${item.courseSlug}`} className="font-semibold text-gray-900 hover:text-primary-700">{item.courseTitle}</Link>
              <p className="text-sm text-gray-600 mt-1">
                {item.isCourseCompleted ? 'Completed' : item.isPaid ? 'Ready to learn' : 'Payment pending'} · <CourseFee fee={item.price} discount={item.discountPercent} />
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Link to={item.firstTopicSlug ? `/courses/${item.courseSlug}/topics/${item.firstTopicSlug}` : `/courses/${item.courseSlug}`}>
                <Button size="sm">Continue learning</Button>
              </Link>
              {!item.isPaid ? (
                <Link to={`/courses/${item.courseSlug}/payment`}>
                  <Button size="sm" variant="outline">Complete payment</Button>
                </Link>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyLearningPage;
